import { Spin } from 'antd'
import React from 'react'

const ModuleLoader = () => {
    return (
        <div className="flex justify-center items-center min-h-[400px]">
            <Spin size="large" />
        </div>

    )
}

export default ModuleLoader